export enum InsightsScopeTabKey {
  my = 'my',
  public = 'public',
}

export const INSIGHTS_SCOPE_TABS = [
  { key: InsightsScopeTabKey.my, value: 'Мои инсайты' },
  { key: InsightsScopeTabKey.public, value: 'Все инсайты' },
];
